export default __webpack_public_path__ + "static/media/guia-2-4.3f8b1cec.svg";